<template>
  <a v-if="!!href" class="btn" :href="href" target="_blank">
    <span class="slot"><slot></slot></span>
  </a>
  <button v-else class="btn">
    <span class="slot"><slot></slot></span>
  </button>
</template>

<script>
export default {
  name: 'Button',

  props: {
    href: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables';

.btn {
  border-color: $colorLight;
  overflow: hidden;
  cursor: pointer;
  @apply .relative .inline-flex .items-center .border-2 .rounded-full .px-6 .py-3 .uppercase .text-xs;

  .slot {
    position: relative;
    z-index: 1;
    transition: color .2s;
  }

  &:hover .slot,
  &:hover .slot i {
    color: #ffffff;
  }

  &:focus {
    outline: none;
  }

  &::after {
    content: "";
    background: $colorLight;
    transition:
      width .2s ease-in-out .2s,
      height .1s ease-in-out,
      background-color .2s ease-in-out;
    z-index: 0;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    @apply .block .absolute .w-0 .h-px;
  }

  &:hover::after {
    width: 100%;
    height: 100%;
    transition:
      width .2s ease-in-out,
      height .1s ease-in-out .2s,
      background-color .2s ease-in-out .2s;
    @apply .w-full .h-full;
  }
}
</style>
